var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletePartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 255,
    viewBox: "0 0 418 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_34865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6388 33.9345L14.8105 85.9966L91.4709 200.597L169.299 148.535L92.6388 33.9345Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.082 143.114L128.194 148.58L89.502 143.003L90.3898 137.537L129.082 143.114Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.597 123.609L115.146 124.414L108.994 162.509L103.438 161.704L109.597 123.609Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9917 75.1987C74.0472 75.275 66.2505 80.5954 56.5741 87.0602C46.8977 93.525 39.0109 98.7135 38.9554 98.6303C38.8999 98.547 46.6965 93.2337 56.373 86.7619C66.0494 80.2901 73.9015 75.1155 73.9917 75.1987Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.583 68.0123C102.639 68.0956 89.6676 76.8633 73.6165 87.601C57.5654 98.3387 44.4831 106.975 44.4415 106.898C44.3999 106.822 57.3434 98.0405 73.4153 87.3027C89.4872 76.565 102.528 67.9291 102.583 68.0123Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.32 76.586C108.375 76.6693 95.4039 85.444 79.3528 96.1817C63.3017 106.919 50.2195 115.555 50.1778 115.472C50.1362 115.389 63.0936 106.621 79.1516 95.8765C95.2097 85.1318 108.264 76.5028 108.32 76.586Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.057 85.1666C114.113 85.2499 101.141 94.0245 85.0904 104.755C69.0393 115.486 55.957 124.136 55.957 124.053C55.957 123.969 68.8659 115.195 84.9239 104.457C100.982 93.7193 114.002 85.0834 114.057 85.1666Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.772 93.7472C119.827 93.8304 106.856 102.598 90.8048 113.336C74.7537 124.074 61.6715 132.71 61.6368 132.626C61.6021 132.543 74.5664 123.775 90.6383 113.038C106.71 102.3 119.772 93.6639 119.772 93.7472Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.887 110.724L287.523 154.448L351.904 250.691L417.267 206.967L352.887 110.724Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.498 202.435L382.755 207.027L350.258 202.345L351 197.753L383.498 202.435Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.129 186.058L371.797 186.731L366.622 218.722L361.961 218.049L367.129 186.058Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.203 145.431C337.259 145.514 330.718 149.988 322.588 155.42C314.459 160.851 307.827 165.193 307.772 165.131C307.716 165.068 314.264 160.58 322.387 155.142C330.51 149.704 337.148 145.313 337.203 145.431Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.239 139.362C361.294 139.445 350.411 146.825 336.961 155.836C323.511 164.846 312.503 172.102 312.447 172.019C312.392 171.935 323.275 164.555 336.725 155.537C350.175 146.52 361.163 139.278 361.239 139.362Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.059 146.562C366.115 146.645 355.231 154.025 341.781 163.043C328.332 172.06 317.323 179.302 317.268 179.219C317.212 179.135 328.061 171.79 341.546 162.772C355.03 153.755 366.018 146.485 366.059 146.562Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.874 153.755C370.929 153.838 360.039 161.219 346.596 170.236C333.153 179.254 322.138 186.495 322.082 186.412C322.027 186.329 332.91 178.955 346.36 169.931C359.81 160.906 370.825 153.686 370.874 153.755Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.729 160.976C375.785 161.059 364.901 168.433 351.451 177.45C338.001 186.467 326.993 193.709 326.938 193.633C326.882 193.557 337.766 186.169 351.215 177.152C364.665 168.134 375.639 160.893 375.729 160.976Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.472 38.1505L178.152 0.00537109L121.985 105.021L193.304 143.166L249.472 38.1505Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.105 110.311L176.583 111.858L165.096 80.1099L169.618 78.5562L181.105 110.311Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.041 87.5317L189.692 92.089L158.159 102.882L156.508 98.3319L188.041 87.5317Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.445 40.6895C210.39 40.7936 203.162 37.034 194.29 32.2963C185.418 27.5587 178.281 23.6257 178.336 23.5216C178.392 23.4176 185.627 27.1772 194.498 31.9148C203.37 36.6525 210.501 40.5785 210.445 40.6895Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.566 59.5775C227.51 59.6816 215.538 53.3832 200.825 45.5172C186.113 37.6512 174.238 31.1864 174.293 31.0823C174.349 30.9783 186.314 37.2697 201.026 45.1426C215.739 53.0156 227.621 59.4735 227.566 59.5775Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.362 67.4369C223.307 67.5409 211.335 61.2495 196.622 53.3835C181.91 45.5175 170.035 39.0457 170.09 38.9417C170.146 38.8377 182.111 45.136 196.823 53.002C211.536 60.868 223.418 67.3328 223.362 67.4369Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.159 75.2957C219.104 75.3998 207.131 69.1084 192.419 61.2424C177.707 53.3764 165.831 46.9323 165.887 46.8075C165.942 46.6826 177.908 52.9948 192.62 60.8609C207.333 68.7269 219.215 75.1917 219.159 75.2957Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.954 83.1551C214.899 83.2591 202.926 76.9677 188.214 69.1017C173.502 61.2357 161.619 54.7708 161.682 54.6668C161.744 54.5628 173.703 60.8542 188.415 68.7202C203.128 76.5862 215.01 83.051 214.954 83.1551Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.472 254.216C400.472 254.313 310.818 254.396 200.243 254.396C89.6683 254.396 0 254.334 0 254.216C0 254.098 89.6405 254.036 200.243 254.036C310.846 254.036 400.472 254.112 400.472 254.216Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.519 111.817L122.964 237.922L119.773 254.431L283.475 253.64C290.828 253.606 297.348 247.079 299.7 237.381L328.736 118.33C330.532 110.97 326.592 103.312 321.015 103.319L155.288 103.493C151.681 103.486 148.449 106.899 147.519 111.817Z",
    fill: "#F6583E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.519 111.817L122.964 237.922L119.773 254.431L283.475 253.64C290.828 253.606 297.348 247.079 299.7 237.381L328.736 118.33C330.532 110.97 326.592 103.312 321.015 103.319L155.288 103.493C151.681 103.486 148.449 106.899 147.519 111.817Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.792 229.363L250.45 89.6545C249.757 83.9318 245.186 79.659 239.796 79.6798L201.784 79.7977C200.371 79.8136 198.977 80.117 197.685 80.6895C196.394 81.2619 195.232 82.0913 194.272 83.1272L176.237 102.321L70.5243 102.889C64.0664 102.924 59.0998 109.042 59.953 115.909L76.0527 245.032C76.7463 250.748 81.3175 255.014 86.6933 255.007L270.962 254.639C291.48 255.062 293.443 249.007 293.443 249.007C269.886 254.216 267.792 229.397 267.792 229.363Z",
    fill: "#F6583E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.335 201.423L182.12 208.096L134.258 165.034L140.473 158.361L188.335 201.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.519 156.883L186.386 163.057L143.074 209.573L136.207 203.393L179.519 156.883Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_34865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 417.266,
    height: 255,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePartner);
export default __webpack_public_path__ + "static/media/deletePartner.90d42eced73c7d347cdeafbc155acb6d.svg";
export { ForwardRef as ReactComponent };